<template>
  <div class="col-12 _col-xl-8 d-flex">
    <div class="card flex-grow-1">
      <h6 class="card-header">Hebergements par type de chambre</h6>
      <div class="card-body position-relative">

        <BarHorizontalComponent
          bar-styles="height: 60px;"
          :data="datas"
        />
        <div class="small text-muted d-flex gap-3 flex-wrap">
          <div class="" v-for="(item, label) in roomsByType" :key="label">{{ label }}: <b>{{ item.count }}</b></div>

          <div class="ms-auto">Total Chambres: <b>{{ roomCount }}</b></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import * as ChartHelper from '@/compositions/chartHelper';
  import { computed } from 'vue';
  import { useBoardFilters } from '@/compositions/useBoardFilters';
  import { GetHotelRoomTypeLabelShort, countRooms } from '@/compositions/helper';

  // Ce widget ne s'intéresse qu'aux inscrits : il n'applique pas le filtre statut
  // (il filtre lui-même sur completionDate) mais applique le filtre organisateurs
  const { travel, participations } = useBoardFilters({ applyStatus: false })

  const inscrits = computed(() => {
    return (participations.value.filter(x=>x.invitation?.completionDate != null && x.invitation?.refusalDate == null) ?? []);
  });

  const rooms = computed(() => {
    return inscrits.value.flatMap(x => x.hotelRooms ?? []) ?? [];
  });

  const roomCount = computed(() => {
    return countRooms(rooms.value);
  })

  const roomsByType = computed(() => {
    const options = travel?.value?.hotels?.flatMap(x=>x.quotaGroups).flatMap(x => x?.rooms).filter(x => x != null).map(x => x.type) ?? [];

    const uniqueOptions = Array.from(new Set(options));
    const result: Record<string, { label: string, count: number }> = {};
    uniqueOptions.forEach(option => {
      const foundRooms = rooms.value.filter(x => x.type === option) ?? [];
      result[option] = {
        label: GetHotelRoomTypeLabelShort(option),
        count: countRooms(foundRooms)
       };
    });
    return result;
  });

  const datas = computed(() => {
    return {
      labels: ["Participants"],
      datasets: roomsByType.value ? Object.keys(roomsByType.value).flatMap((optionId, index) => {
        const res = [{
          label: optionId,
          data: [roomsByType.value[optionId].count],
          backgroundColor: [ChartHelper.Colors[index % ChartHelper.Colors.length]],
          borderColor: [ChartHelper.Borders[index % ChartHelper.Borders.length]],
        }];
        return res;
      }) : []
    }
  });
</script>
